import * as React from "react";

import { cn } from "../lib/utils";

const sizeClasses = {
  default: "h-10 px-3 py-2",
  sm: "h-9 px-3 py-1",
  lg: "h-11 px-4 py-2",
} as const;

type InputSize = keyof typeof sizeClasses;

function Input({
  className,
  type,
  size = "default",
  ref,
  ...props
}: Omit<React.ComponentProps<"input">, "size"> & { size?: InputSize }) {
  return (
    <input
      type={type}
      className={cn(
        "flex w-full rounded-md border border-input dark:border-muted-foreground/40 bg-background text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        sizeClasses[size],
        className,
      )}
      ref={ref}
      {...props}
    />
  );
}

export { Input };
export type { InputSize };
